module.exports = __webpack_public_path__ + "static/media/yuntaishan.cf0ab671.webp";